export default __webpack_public_path__ + "static/media/newLogo.98078a48.svg";